var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100"},[_c('LineChart',{attrs:{"is-loading":_vm.isLoading,"chart-data":_vm.chartData,"title":_vm.title,"colors":_vm.colors,"height":_vm.height,"width":_vm.width}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }